module.exports = __webpack_public_path__ + "static/img/carousel_btthk.9554b45.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/carousel_btthk.png
// module id = jQk9
// module chunks = 0